import React from "react"

import { IconSize, IconColorKeys, IconLetterExtraLarge } from "@izettle/otto"

import { IconMetadata } from "../../svg-icon"
import { EmptyStateBase, EmptyStateCTAButtonProps } from "../empty-state-base"

import { SvgIconStyled } from "./styles"

export type EmptyStateIconProps = {
  icon?: IconMetadata<IconSize.ExtraLarge | IconSize.Large>
  color?: IconColorKeys
  headline: string
  subtitle: string
  ctaButtonProps?: EmptyStateCTAButtonProps
}

export const EmptyStateIcon: React.FC<EmptyStateIconProps> = ({
  icon,
  color,
  headline,
  subtitle,
  ctaButtonProps,
}) => {
  return (
    <EmptyStateBase
      headline={headline}
      subtitle={subtitle}
      ctaButtonProps={ctaButtonProps}
    >
      <SvgIconStyled alt={headline} icon={icon ?? IconLetterExtraLarge} color={color} />
    </EmptyStateBase>
  )
}
